/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransferDestinationsRouteImport } from './routes/transfer-destinations'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as KnowledgeBaseRouteImport } from './routes/knowledge-base'
import { Route as KampangenRouteImport } from './routes/kampangen'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as GoogleCalendarCallbackRouteImport } from './routes/google-calendar-callback'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as ChatsRouteImport } from './routes/chats'
import { Route as ChatWidgetsRouteImport } from './routes/chat-widgets'
import { Route as CallsRouteImport } from './routes/calls'
import { Route as CallbacksRouteImport } from './routes/callbacks'
import { Route as CalendarConfigurationRouteImport } from './routes/calendar-configuration'
import { Route as BookingsRouteImport } from './routes/bookings'
import { Route as BookingKeysRouteImport } from './routes/booking-keys'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as AppointmentsConfigurationRouteImport } from './routes/appointments-configuration'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AgentConfigurationRouteImport } from './routes/agent-configuration'
import { Route as ActivitiesRouteImport } from './routes/activities'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentNewRouteImport } from './routes/agent.new'
import { Route as AgentIdRouteImport } from './routes/agent.$id'
import { Route as AdminVoicesRouteImport } from './routes/admin/voices'
import { Route as AdminTelephonyRouteImport } from './routes/admin/telephony'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AdminBillingRouteImport } from './routes/admin/billing'
import { Route as AdminVoicesIndexRouteImport } from './routes/admin/voices.index'
import { Route as AdminTelephonyIndexRouteImport } from './routes/admin/telephony.index'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations.index'
import { Route as AdminBillingIndexRouteImport } from './routes/admin/billing.index'
import { Route as AdminOrganizationsOrgIdRouteImport } from './routes/admin/organizations.$orgId'
import { Route as AdminBillingOrgIdRouteImport } from './routes/admin/billing.$orgId'

const TransferDestinationsRoute = TransferDestinationsRouteImport.update({
  id: '/transfer-destinations',
  path: '/transfer-destinations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeBaseRoute = KnowledgeBaseRouteImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => rootRouteImport,
} as any)
const KampangenRoute = KampangenRouteImport.update({
  id: '/kampangen',
  path: '/kampangen',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const GoogleCalendarCallbackRoute = GoogleCalendarCallbackRouteImport.update({
  id: '/google-calendar-callback',
  path: '/google-calendar-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsRoute = ContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatsRoute = ChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatWidgetsRoute = ChatWidgetsRouteImport.update({
  id: '/chat-widgets',
  path: '/chat-widgets',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsRoute = CallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbacksRoute = CallbacksRouteImport.update({
  id: '/callbacks',
  path: '/callbacks',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarConfigurationRoute = CalendarConfigurationRouteImport.update({
  id: '/calendar-configuration',
  path: '/calendar-configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsRoute = BookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingKeysRoute = BookingKeysRouteImport.update({
  id: '/booking-keys',
  path: '/booking-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantRoute = AssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentsConfigurationRoute =
  AppointmentsConfigurationRouteImport.update({
    id: '/appointments-configuration',
    path: '/appointments-configuration',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentConfigurationRoute = AgentConfigurationRouteImport.update({
  id: '/agent-configuration',
  path: '/agent-configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivitiesRoute = ActivitiesRouteImport.update({
  id: '/activities',
  path: '/activities',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentNewRoute = AgentNewRouteImport.update({
  id: '/agent/new',
  path: '/agent/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentIdRoute = AgentIdRouteImport.update({
  id: '/agent/$id',
  path: '/agent/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVoicesRoute = AdminVoicesRouteImport.update({
  id: '/admin/voices',
  path: '/admin/voices',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTelephonyRoute = AdminTelephonyRouteImport.update({
  id: '/admin/telephony',
  path: '/admin/telephony',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/admin/organizations',
  path: '/admin/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/admin/billing',
  path: '/admin/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVoicesIndexRoute = AdminVoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminVoicesRoute,
} as any)
const AdminTelephonyIndexRoute = AdminTelephonyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminTelephonyRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminOrganizationsRoute,
} as any)
const AdminBillingIndexRoute = AdminBillingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AdminOrganizationsOrgIdRoute = AdminOrganizationsOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AdminOrganizationsRoute,
} as any)
const AdminBillingOrgIdRoute = AdminBillingOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AdminBillingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activities': typeof ActivitiesRoute
  '/agent-configuration': typeof AgentConfigurationRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments-configuration': typeof AppointmentsConfigurationRoute
  '/assistant': typeof AssistantRoute
  '/booking-keys': typeof BookingKeysRoute
  '/bookings': typeof BookingsRoute
  '/calendar-configuration': typeof CalendarConfigurationRoute
  '/callbacks': typeof CallbacksRoute
  '/calls': typeof CallsRoute
  '/chat-widgets': typeof ChatWidgetsRoute
  '/chats': typeof ChatsRoute
  '/contacts': typeof ContactsRoute
  '/dashboard': typeof DashboardRoute
  '/google-calendar-callback': typeof GoogleCalendarCallbackRoute
  '/integrations': typeof IntegrationsRoute
  '/kampangen': typeof KampangenRoute
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/organization': typeof OrganizationRoute
  '/settings': typeof SettingsRoute
  '/transfer-destinations': typeof TransferDestinationsRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/organizations': typeof AdminOrganizationsRouteWithChildren
  '/admin/telephony': typeof AdminTelephonyRouteWithChildren
  '/admin/voices': typeof AdminVoicesRouteWithChildren
  '/agent/$id': typeof AgentIdRoute
  '/agent/new': typeof AgentNewRoute
  '/admin/billing/$orgId': typeof AdminBillingOrgIdRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/telephony/': typeof AdminTelephonyIndexRoute
  '/admin/voices/': typeof AdminVoicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activities': typeof ActivitiesRoute
  '/agent-configuration': typeof AgentConfigurationRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments-configuration': typeof AppointmentsConfigurationRoute
  '/assistant': typeof AssistantRoute
  '/booking-keys': typeof BookingKeysRoute
  '/bookings': typeof BookingsRoute
  '/calendar-configuration': typeof CalendarConfigurationRoute
  '/callbacks': typeof CallbacksRoute
  '/calls': typeof CallsRoute
  '/chat-widgets': typeof ChatWidgetsRoute
  '/chats': typeof ChatsRoute
  '/contacts': typeof ContactsRoute
  '/dashboard': typeof DashboardRoute
  '/google-calendar-callback': typeof GoogleCalendarCallbackRoute
  '/integrations': typeof IntegrationsRoute
  '/kampangen': typeof KampangenRoute
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/organization': typeof OrganizationRoute
  '/settings': typeof SettingsRoute
  '/transfer-destinations': typeof TransferDestinationsRoute
  '/agent/$id': typeof AgentIdRoute
  '/agent/new': typeof AgentNewRoute
  '/admin/billing/$orgId': typeof AdminBillingOrgIdRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/billing': typeof AdminBillingIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/telephony': typeof AdminTelephonyIndexRoute
  '/admin/voices': typeof AdminVoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activities': typeof ActivitiesRoute
  '/agent-configuration': typeof AgentConfigurationRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments-configuration': typeof AppointmentsConfigurationRoute
  '/assistant': typeof AssistantRoute
  '/booking-keys': typeof BookingKeysRoute
  '/bookings': typeof BookingsRoute
  '/calendar-configuration': typeof CalendarConfigurationRoute
  '/callbacks': typeof CallbacksRoute
  '/calls': typeof CallsRoute
  '/chat-widgets': typeof ChatWidgetsRoute
  '/chats': typeof ChatsRoute
  '/contacts': typeof ContactsRoute
  '/dashboard': typeof DashboardRoute
  '/google-calendar-callback': typeof GoogleCalendarCallbackRoute
  '/integrations': typeof IntegrationsRoute
  '/kampangen': typeof KampangenRoute
  '/knowledge-base': typeof KnowledgeBaseRoute
  '/organization': typeof OrganizationRoute
  '/settings': typeof SettingsRoute
  '/transfer-destinations': typeof TransferDestinationsRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/organizations': typeof AdminOrganizationsRouteWithChildren
  '/admin/telephony': typeof AdminTelephonyRouteWithChildren
  '/admin/voices': typeof AdminVoicesRouteWithChildren
  '/agent/$id': typeof AgentIdRoute
  '/agent/new': typeof AgentNewRoute
  '/admin/billing/$orgId': typeof AdminBillingOrgIdRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/telephony/': typeof AdminTelephonyIndexRoute
  '/admin/voices/': typeof AdminVoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activities'
    | '/agent-configuration'
    | '/analytics'
    | '/appointments-configuration'
    | '/assistant'
    | '/booking-keys'
    | '/bookings'
    | '/calendar-configuration'
    | '/callbacks'
    | '/calls'
    | '/chat-widgets'
    | '/chats'
    | '/contacts'
    | '/dashboard'
    | '/google-calendar-callback'
    | '/integrations'
    | '/kampangen'
    | '/knowledge-base'
    | '/organization'
    | '/settings'
    | '/transfer-destinations'
    | '/admin/billing'
    | '/admin/organizations'
    | '/admin/telephony'
    | '/admin/voices'
    | '/agent/$id'
    | '/agent/new'
    | '/admin/billing/$orgId'
    | '/admin/organizations/$orgId'
    | '/admin/billing/'
    | '/admin/organizations/'
    | '/admin/telephony/'
    | '/admin/voices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activities'
    | '/agent-configuration'
    | '/analytics'
    | '/appointments-configuration'
    | '/assistant'
    | '/booking-keys'
    | '/bookings'
    | '/calendar-configuration'
    | '/callbacks'
    | '/calls'
    | '/chat-widgets'
    | '/chats'
    | '/contacts'
    | '/dashboard'
    | '/google-calendar-callback'
    | '/integrations'
    | '/kampangen'
    | '/knowledge-base'
    | '/organization'
    | '/settings'
    | '/transfer-destinations'
    | '/agent/$id'
    | '/agent/new'
    | '/admin/billing/$orgId'
    | '/admin/organizations/$orgId'
    | '/admin/billing'
    | '/admin/organizations'
    | '/admin/telephony'
    | '/admin/voices'
  id:
    | '__root__'
    | '/'
    | '/activities'
    | '/agent-configuration'
    | '/analytics'
    | '/appointments-configuration'
    | '/assistant'
    | '/booking-keys'
    | '/bookings'
    | '/calendar-configuration'
    | '/callbacks'
    | '/calls'
    | '/chat-widgets'
    | '/chats'
    | '/contacts'
    | '/dashboard'
    | '/google-calendar-callback'
    | '/integrations'
    | '/kampangen'
    | '/knowledge-base'
    | '/organization'
    | '/settings'
    | '/transfer-destinations'
    | '/admin/billing'
    | '/admin/organizations'
    | '/admin/telephony'
    | '/admin/voices'
    | '/agent/$id'
    | '/agent/new'
    | '/admin/billing/$orgId'
    | '/admin/organizations/$orgId'
    | '/admin/billing/'
    | '/admin/organizations/'
    | '/admin/telephony/'
    | '/admin/voices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivitiesRoute: typeof ActivitiesRoute
  AgentConfigurationRoute: typeof AgentConfigurationRoute
  AnalyticsRoute: typeof AnalyticsRoute
  AppointmentsConfigurationRoute: typeof AppointmentsConfigurationRoute
  AssistantRoute: typeof AssistantRoute
  BookingKeysRoute: typeof BookingKeysRoute
  BookingsRoute: typeof BookingsRoute
  CalendarConfigurationRoute: typeof CalendarConfigurationRoute
  CallbacksRoute: typeof CallbacksRoute
  CallsRoute: typeof CallsRoute
  ChatWidgetsRoute: typeof ChatWidgetsRoute
  ChatsRoute: typeof ChatsRoute
  ContactsRoute: typeof ContactsRoute
  DashboardRoute: typeof DashboardRoute
  GoogleCalendarCallbackRoute: typeof GoogleCalendarCallbackRoute
  IntegrationsRoute: typeof IntegrationsRoute
  KampangenRoute: typeof KampangenRoute
  KnowledgeBaseRoute: typeof KnowledgeBaseRoute
  OrganizationRoute: typeof OrganizationRoute
  SettingsRoute: typeof SettingsRoute
  TransferDestinationsRoute: typeof TransferDestinationsRoute
  AdminBillingRoute: typeof AdminBillingRouteWithChildren
  AdminOrganizationsRoute: typeof AdminOrganizationsRouteWithChildren
  AdminTelephonyRoute: typeof AdminTelephonyRouteWithChildren
  AdminVoicesRoute: typeof AdminVoicesRouteWithChildren
  AgentIdRoute: typeof AgentIdRoute
  AgentNewRoute: typeof AgentNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transfer-destinations': {
      id: '/transfer-destinations'
      path: '/transfer-destinations'
      fullPath: '/transfer-destinations'
      preLoaderRoute: typeof TransferDestinationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge-base': {
      id: '/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof KnowledgeBaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kampangen': {
      id: '/kampangen'
      path: '/kampangen'
      fullPath: '/kampangen'
      preLoaderRoute: typeof KampangenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/google-calendar-callback': {
      id: '/google-calendar-callback'
      path: '/google-calendar-callback'
      fullPath: '/google-calendar-callback'
      preLoaderRoute: typeof GoogleCalendarCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts': {
      id: '/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chats': {
      id: '/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof ChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-widgets': {
      id: '/chat-widgets'
      path: '/chat-widgets'
      fullPath: '/chat-widgets'
      preLoaderRoute: typeof ChatWidgetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls': {
      id: '/calls'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof CallsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callbacks': {
      id: '/callbacks'
      path: '/callbacks'
      fullPath: '/callbacks'
      preLoaderRoute: typeof CallbacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar-configuration': {
      id: '/calendar-configuration'
      path: '/calendar-configuration'
      fullPath: '/calendar-configuration'
      preLoaderRoute: typeof CalendarConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking-keys': {
      id: '/booking-keys'
      path: '/booking-keys'
      fullPath: '/booking-keys'
      preLoaderRoute: typeof BookingKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant': {
      id: '/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointments-configuration': {
      id: '/appointments-configuration'
      path: '/appointments-configuration'
      fullPath: '/appointments-configuration'
      preLoaderRoute: typeof AppointmentsConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-configuration': {
      id: '/agent-configuration'
      path: '/agent-configuration'
      fullPath: '/agent-configuration'
      preLoaderRoute: typeof AgentConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activities': {
      id: '/activities'
      path: '/activities'
      fullPath: '/activities'
      preLoaderRoute: typeof ActivitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/new': {
      id: '/agent/new'
      path: '/agent/new'
      fullPath: '/agent/new'
      preLoaderRoute: typeof AgentNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/$id': {
      id: '/agent/$id'
      path: '/agent/$id'
      fullPath: '/agent/$id'
      preLoaderRoute: typeof AgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/voices': {
      id: '/admin/voices'
      path: '/admin/voices'
      fullPath: '/admin/voices'
      preLoaderRoute: typeof AdminVoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/telephony': {
      id: '/admin/telephony'
      path: '/admin/telephony'
      fullPath: '/admin/telephony'
      preLoaderRoute: typeof AdminTelephonyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/admin/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/voices/': {
      id: '/admin/voices/'
      path: '/'
      fullPath: '/admin/voices/'
      preLoaderRoute: typeof AdminVoicesIndexRouteImport
      parentRoute: typeof AdminVoicesRoute
    }
    '/admin/telephony/': {
      id: '/admin/telephony/'
      path: '/'
      fullPath: '/admin/telephony/'
      preLoaderRoute: typeof AdminTelephonyIndexRouteImport
      parentRoute: typeof AdminTelephonyRoute
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminOrganizationsRoute
    }
    '/admin/billing/': {
      id: '/admin/billing/'
      path: '/'
      fullPath: '/admin/billing/'
      preLoaderRoute: typeof AdminBillingIndexRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/admin/organizations/$orgId': {
      id: '/admin/organizations/$orgId'
      path: '/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof AdminOrganizationsOrgIdRouteImport
      parentRoute: typeof AdminOrganizationsRoute
    }
    '/admin/billing/$orgId': {
      id: '/admin/billing/$orgId'
      path: '/$orgId'
      fullPath: '/admin/billing/$orgId'
      preLoaderRoute: typeof AdminBillingOrgIdRouteImport
      parentRoute: typeof AdminBillingRoute
    }
  }
}

interface AdminBillingRouteChildren {
  AdminBillingOrgIdRoute: typeof AdminBillingOrgIdRoute
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
}

const AdminBillingRouteChildren: AdminBillingRouteChildren = {
  AdminBillingOrgIdRoute: AdminBillingOrgIdRoute,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
}

const AdminBillingRouteWithChildren = AdminBillingRoute._addFileChildren(
  AdminBillingRouteChildren,
)

interface AdminOrganizationsRouteChildren {
  AdminOrganizationsOrgIdRoute: typeof AdminOrganizationsOrgIdRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
}

const AdminOrganizationsRouteChildren: AdminOrganizationsRouteChildren = {
  AdminOrganizationsOrgIdRoute: AdminOrganizationsOrgIdRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
}

const AdminOrganizationsRouteWithChildren =
  AdminOrganizationsRoute._addFileChildren(AdminOrganizationsRouteChildren)

interface AdminTelephonyRouteChildren {
  AdminTelephonyIndexRoute: typeof AdminTelephonyIndexRoute
}

const AdminTelephonyRouteChildren: AdminTelephonyRouteChildren = {
  AdminTelephonyIndexRoute: AdminTelephonyIndexRoute,
}

const AdminTelephonyRouteWithChildren = AdminTelephonyRoute._addFileChildren(
  AdminTelephonyRouteChildren,
)

interface AdminVoicesRouteChildren {
  AdminVoicesIndexRoute: typeof AdminVoicesIndexRoute
}

const AdminVoicesRouteChildren: AdminVoicesRouteChildren = {
  AdminVoicesIndexRoute: AdminVoicesIndexRoute,
}

const AdminVoicesRouteWithChildren = AdminVoicesRoute._addFileChildren(
  AdminVoicesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivitiesRoute: ActivitiesRoute,
  AgentConfigurationRoute: AgentConfigurationRoute,
  AnalyticsRoute: AnalyticsRoute,
  AppointmentsConfigurationRoute: AppointmentsConfigurationRoute,
  AssistantRoute: AssistantRoute,
  BookingKeysRoute: BookingKeysRoute,
  BookingsRoute: BookingsRoute,
  CalendarConfigurationRoute: CalendarConfigurationRoute,
  CallbacksRoute: CallbacksRoute,
  CallsRoute: CallsRoute,
  ChatWidgetsRoute: ChatWidgetsRoute,
  ChatsRoute: ChatsRoute,
  ContactsRoute: ContactsRoute,
  DashboardRoute: DashboardRoute,
  GoogleCalendarCallbackRoute: GoogleCalendarCallbackRoute,
  IntegrationsRoute: IntegrationsRoute,
  KampangenRoute: KampangenRoute,
  KnowledgeBaseRoute: KnowledgeBaseRoute,
  OrganizationRoute: OrganizationRoute,
  SettingsRoute: SettingsRoute,
  TransferDestinationsRoute: TransferDestinationsRoute,
  AdminBillingRoute: AdminBillingRouteWithChildren,
  AdminOrganizationsRoute: AdminOrganizationsRouteWithChildren,
  AdminTelephonyRoute: AdminTelephonyRouteWithChildren,
  AdminVoicesRoute: AdminVoicesRouteWithChildren,
  AgentIdRoute: AgentIdRoute,
  AgentNewRoute: AgentNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
